const question2 = {
    'question': 'Z jakimi problemami wychowawczymi warto zgłosić się po pomoc psychologa?',
    'answer': 'Warto zgłosić się po pomoc psychologa, jeśli: Czujesz się przytłoczony i bezradny w związku z problemami wychowawczymi swojego dziecka, masz wątpliwości co do tego, jak postępować w danej sytuacji wychowawczej, chcesz poznać lepiej potrzeby i rozwój swojego dziecka oraz chcesz poprawić jakość relacji z dzieckiem.'
}

export default question2;